
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationStart,
    setOperationError,
} from '../common/client/sagas/common';

import { workGetOpsub } from './common/opsub';

import { knDataExec } from './serverApi/project';

export const ANALYZE_DEFUNCT_PAR_ACTION_TYPE = createActionTypes('analyzeDefunctPar/ANALYZE_DEFUNCT_PAR');
export const GET_OPSUB_ACTUAL_ACTION_TYPE = createActionTypes('analyzeDefunctPar/GET_OPSUB_ACTUAL');
export const SET_ISKN_DATE = 'analyzeDefunctPar/SET_ISKN_DATE';
export const SET_OPSUB_ITEM = 'analyzeDefunctPar/SET_OPSUB_ITEM';

export default function getActions(dispatch) {
    return {
        analyzeDefunctPar: (token, projectId, katuzeKod, isknDates, opsubId) => dispatch({
            type: ANALYZE_DEFUNCT_PAR_ACTION_TYPE.DEFAULT,
            token, projectId, katuzeKod, isknDates, opsubId,
            operation: ANALYZE_DEFUNCT_PAR_ACTION_TYPE.DEFAULT
        }),
        getOpsubActual: (token, projectId, katuzeKod, isknDate) => dispatch({
            type: GET_OPSUB_ACTUAL_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod, isknDate,
            operation: GET_OPSUB_ACTUAL_ACTION_TYPE.DEFAULT
        }),
        setIsknDate: (isknDate) => dispatch({
            type: SET_ISKN_DATE, isknDate
        }),
        setOpsubItem: (opsubItem) => dispatch({
            type: SET_OPSUB_ITEM, opsubItem
        })
    };
}

function* workAnalyzeDefunctPar(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: ANALYZE_DEFUNCT_PAR_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: ANALYZE_DEFUNCT_PAR_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, ANALYZE_DEFUNCT_PAR_ACTION_TYPE);
    }
}

export function* watchAnalyzeDefunctPar(options) {
    yield takeEvery(
        ANALYZE_DEFUNCT_PAR_ACTION_TYPE.DEFAULT, workAnalyzeDefunctPar, options,
        'Analýza zaniklých parcel'
    );
}

export function* watchGetOpsubActual(options) {
    yield takeEvery(
        GET_OPSUB_ACTUAL_ACTION_TYPE.DEFAULT, workGetOpsub, options, GET_OPSUB_ACTUAL_ACTION_TYPE
    );
}
